import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';
import { StructureComponent } from '../../../views/site/structure/structure.component';
import {
    OpenItemContextMenuData,
    CopyItemContextMenuData,
    PasteItemContextMenuData,
    MagicStructureItemContextMenuData,
    SendNotificationItemContextMenuData,
    ExportAllCopiesItemContextMenuData,
    DeleteItemContextMenuData,
    //ScheduleEventForItemContextMenuData
} from './item-menu-classes';
import { ClipboardService } from '../../services/clipboard.service';
import { FolderService } from '../../services/folder.service';
import { CurrentSiteService } from '../../services/current-site.service';
import { FormInstanceService } from '../../services/form-instance.service';
import { CurrentUserService } from '../../../security/current-user.service';

// Menu Data for the Context Menu opened when right-clicking on a ListItem (aka a Form or Folder)
export class StructureItemContextMenuData {
    // Properties.
    //private structureComponent: StructureComponent;
    private itemContextMenuData: IContextMenuItem[];

    public get ItemContextMenuData(): IContextMenuItem[] {
        return this.itemContextMenuData;
    }

    // Constructor.
    public constructor(private structureComponent: StructureComponent,
        private dialog: MatDialog,
        private clipboardService: ClipboardService,
        private folderService: FolderService,
        private currentSiteService: CurrentSiteService,
        private formInstanceService: FormInstanceService,
        private currentUserService: CurrentUserService) {
        //this.structureComponent = structureComponent;

        this.itemContextMenuData = [
            new OpenItemContextMenuData('Open', this.structureComponent),
            new CopyItemContextMenuData('Copy ...', this.structureComponent, this.dialog),
            new PasteItemContextMenuData('Paste ...', this.structureComponent, this.clipboardService, this.folderService),
            new PasteItemContextMenuData('Paste Reference ...', this.structureComponent, this.clipboardService, this.folderService),
            // new MagicStructureItemContextMenuData(this.structureComponent, this.currentSiteService, this.dialog),
            // Note:  ScheduleEventForItemContextMenuData is not yet ready to use.
            //new ScheduleEventForItemContextMenuData('Schedule Event ...', this.structureComponent)
            // new SendNotificationItemContextMenuData('Send Notification ...', this.structureComponent, this.currentSiteService),
            new ExportAllCopiesItemContextMenuData('Export All Copies ...', this.structureComponent, this.dialog, this.formInstanceService),
            new DeleteItemContextMenuData('Delete ...', this.structureComponent)
        ];

        if (this.currentUserService.user.isSystemAdmin) {
            this.itemContextMenuData.splice(4, 0, new MagicStructureItemContextMenuData(this.structureComponent, this.currentSiteService, this.dialog));
            this.itemContextMenuData.splice(5, 0, new SendNotificationItemContextMenuData('Send Notification ...', this.structureComponent, this.currentSiteService));
        }
    }
}
